export default "__VITE_ASSET__D4g$RwAV__"